/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

/**
 * create console.debug that just show in dev mode.
 * Timestamp is generated as well
 *
 * @param {string} filename
 * @param {string} message
 */
export const logging = (filename: string, message: string) => {
  // check the environment variable if VUE_APP_LOGGING is true show the logs
  if (process.env.VUE_APP_LOGGING === 'true') {
    const timestamp = new Date();
    console.debug(`${filename}, message: ${message}, timestamp: ${timestamp}`);
  }
};
